import { Skeleton, Stack } from '@mui/material';

import Typography from '../../../../components/Typography';
import { usePollContext } from '../../Context';
import { getIsPollPublished } from '../helpers';
import QuestionDescriptionSkeleton from './QuestionDescription/skeleton';
import QuestionOptionsSkeleton from './QuestionOptions/skeleton';
import { LeftPart, pollQuestionClasses, RightPart } from './styles';

export interface PollQuestionSkeletonProps {
  className?: string;
}

const PollQuestionSkeleton = ({ className }: PollQuestionSkeletonProps) => {
  const { poll } = usePollContext();

  const isPollPublished = getIsPollPublished(poll);
  return (
    <Stack direction="row" gap={2} component="form" className={className}>
      <LeftPart flex={1}>
        <Typography variant="titleBold" visibility={isPollPublished ? 'hidden' : 'visible'}>
          <Skeleton variant="text" width="25%" height="100%" />
        </Typography>
        <QuestionDescriptionSkeleton className={pollQuestionClasses.questionDescription} />
      </LeftPart>
      <RightPart flex={1}>
        <Typography variant="titleBold" className={pollQuestionClasses.questionOptionsLabel}>
          <Skeleton variant="text" width="25%" height="100%" />
        </Typography>
        <QuestionOptionsSkeleton className={pollQuestionClasses.questionOptions} />
      </RightPart>
    </Stack>
  );
};

export default PollQuestionSkeleton;
